import { ReactElement, useEffect } from 'react';

type FaqListProps =  {
    faq: any;
}

const FaqList = ({ faq } : FaqListProps ) : ReactElement => {

    useEffect(() => {
        const faqQuestions = document.querySelectorAll('.faq-list-header');
        faqQuestions.forEach(q => q.addEventListener('click', () => {
            if(!q.nextElementSibling.classList.contains('show-faq')) {
                const openedFaq = document.querySelector('.show-faq');
                if(!!openedFaq) {
                    openedFaq.classList.remove('show-faq');
                    openedFaq.previousElementSibling.firstElementChild.firstElementChild.classList.remove('minus');
                }
                q.nextElementSibling.classList.add('show-faq');
                q.lastElementChild.firstElementChild.classList.add('minus');
            } else {
                q.nextElementSibling.classList.remove('show-faq');
                q.lastElementChild.firstElementChild.classList.remove('minus');
            }
            
        }));
    }, []);

    return(
        <span dangerouslySetInnerHTML={{__html: faq}}></span>
    )
}

export default FaqList;